import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";

export class CalendarClass extends Component {
  constructor() {
    super();
    this.state = {
      showEmailForm: false,
      emailMessage: "",
      loaded: false,
      instructorList: [],
      bookEdited: false,
      bookId: "",
      bookDate: "",
      bookDateToDisplay: "",
      bookYear: "",
      bookMonth: "",
      bookDay: "",
      bookDayOfWeek: "",
      bookStartTime: "",
      bookEndTime: "",
      bookPrice: "",
      bookPriceToDisplay: "",
      bookCurrencyCode: "",
      bookCurrencySymbol: "",
      bookLastUpdatedDateTime: "",
      bookServiceName: "",
      bookServiceId: "",
      bookSetId: "",
      bookInstructorIds: [],
      bookInstructorDetails: [],
      bookInstructorsArray: [],
      bookClientsArray: [],
      bookLevel: "",
      pickListAvailable: [],
      pickListSelected: [],
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }
    this.getInstructors();
    this.getClass();
  };

  getInstructors = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  };

  getClass = async () => {
    this.setState({ loaded: false });
    let instructorNamesArray = [];
    let clientNamesArray = [];
    let i = 0;

    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.id = localStorage.getItem("bookId");

    await api("bookApiV1BookGetById", bookRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }
        if (res.data.date) {
          res.data.date = res.data.date.toJSON();
        }

        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState(
            {
              bookId: bookResponse.id,
              bookDate: bookResponse.date,
              bookDateToDisplay: bookResponse.dateToDisplay,
              bookYear: bookResponse.year,
              bookMonth: bookResponse.month,
              bookDay: bookResponse.day,
              bookDayOfWeek: bookResponse.dayOfWeek,
              bookStartTime: bookResponse.startTime,
              bookEndTime: bookResponse.endTime,
              bookPrice: bookResponse.price,
              bookPriceToDisplay: bookResponse.priceToDisplay,
              bookCurrencyCode: bookResponse.currencyCode,
              bookCurrencySymbol: bookResponse.currencySymbol,
              bookLastUpdatedDateTime: bookResponse.lastUpdatedDateTime,
              bookServiceName: bookResponse.bookedServiceName,
              bookServiceId: bookResponse.serviceId,
              bookSetId: bookResponse.setId,
              bookInstructorIds: bookResponse.instructorIds,
              bookInstructorDetails: bookResponse.instructorDetails || [],
              bookUserDetails: bookResponse.bookedUserDetails || [],
              bookLevel: bookResponse.level,
              pickListSelected: bookResponse.instructorDetails,
            },
            () => {
              if (Array.isArray(this.state.pickListSelected)) {
                this.removePickListDuplicates();
              }

              if (Array.isArray(this.state.bookInstructorDetails)) {
                i = 0;

                this.state.bookInstructorDetails.forEach((e) => {
                  instructorNamesArray[i] = (
                    <li key={i}>{e.firstName + " " + e.surname}</li>
                  );
                  i++;
                });

                this.setState({
                  bookInstructorsArray: instructorNamesArray,
                });
              }

              if (Array.isArray(this.state.bookUserDetails)) {
                i = 0;

                this.state.bookUserDetails.forEach((e) => {
                  clientNamesArray[i] = (
                    <li key={i}>{e.firstName + " " + e.surname}</li>
                  );
                  i++;
                });

                this.setState({
                  bookClientsArray: clientNamesArray,
                });
              }
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Class could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookGetById has failed");
      }
    });

    this.setState({ loaded: true });
  };

  removePickListDuplicates = () => {
    let i = 0;

    this.state.pickListAvailable.forEach((e) => {
      this.state.pickListSelected.forEach((f) => {
        if (e.id === f.id) {
          let pickListAvailable = this.state.pickListAvailable;
          pickListAvailable.splice(i, 1);
          this.setState({ pickListAvailable: pickListAvailable });
          i--;
        }
      });
      i++;
    });
  };

  updateClass = async (ids) => {
    let idArray = [];

    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.id = this.state.bookId;
    bookRequest.lastUpdatedDateTime = this.state.bookLastUpdatedDateTime;
    bookRequest.currencyCode = this.state.bookCurrencyCode;
    if (ids) {
      bookRequest.instructorIds = ids;
    }
    if (Array.isArray(this.state.pickListSelected)) {
      this.state.pickListSelected.forEach((e) => {
        idArray.push(e.id);
      });
      bookRequest.instructorIds = idArray;
    }

    await api("bookApiV1BookUpdate", bookRequest).then((res) => {
      if (res.data) {
        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState({ bookEdited: false }, () => {
            this.getClass();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Class could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookUpdate has failed");
      }
    });
  };

  sendEmail = async () => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.userId = localStorage.getItem("userId");
    bookRequest.id = this.state.bookId;
    bookRequest.identifier = "CREATE";
    bookRequest.emailBody = this.state.emailMessage;

    await api("bookApiV1BookEmailClass", bookRequest).then((res) => {
      if (res.data) {
        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState({ emailMessage: "" }, () => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "The email has been sent",
              life: 3000,
            });
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Email could not be sent, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookEmailClass has failed");
      }
    });
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <pr.Dialog
            header="Enter Message to Send"
            footer={
              <div>
                <pr.Button
                  className="secondary-btn"
                  label="Send"
                  icon="pi pi-check"
                  onClick={() => {
                    this.setState({ showEmailForm: false }, () => {
                      this.sendEmail();
                    });
                  }}
                  style={{
                    float: "right",
                  }}
                />
                <pr.Button
                  className="secondary-btn"
                  label="Cancel"
                  icon="pi pi-times"
                  onClick={() => {
                    this.setState({ showEmailForm: false });
                  }}
                  style={{
                    float: "right",
                  }}
                />
              </div>
            }
            visible={this.state.showEmailForm}
            onHide={() => {
              this.setState({ showEmailForm: false });
            }}
            modal={true}
            blockScroll={true}
            style={{ width: "80vw" }}
          >
            <textarea
              rows="10"
              value={this.state.emailMessage}
              onChange={(e) => {
                this.setState({
                  emailMessage: e.target.value,
                });
              }}
              style={{ width: "100%", resize: "none" }}
            />
          </pr.Dialog>
          {/*Class Card*/}
          {this.state.bookEdited ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  {localStorage.getItem("roleType") !== "10" ? (
                    <label />
                  ) : (
                    <pr.Button
                      className="secondary-btn"
                      icon="pi pi-pencil"
                      onClick={() => {
                        this.setState({
                          bookEdited: true,
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  )}
                  <h1>Class Overview</h1>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Date: </b>
                    <label>{this.state.bookDateToDisplay || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Time: </b>
                    <label>{this.state.bookStartTime || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <br />
                    <ul>
                      {this.state.bookInstructorDetails.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.bookInstructorsArray
                      )}
                    </ul>
                  </div>
                  <div className="ui-g-12">
                    <b>Client(s): </b>
                    <br />
                    <ul>
                      {this.state.bookUserDetails.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.bookClientsArray
                      )}
                    </ul>
                  </div>
                  {localStorage.getItem("roleType") === "10" ? (
                    <div className="ui-g-12">
                      <pr.Button
                        className="secondary-btn"
                        label="Email Clients"
                        icon="pi pi-envelope"
                        onClick={() => {
                          this.setState({
                            showEmailForm: true,
                          });
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                </div>
              </div>
            </div>
          )}

          {/*Editing Class Card*/}
          {!this.state.bookEdited ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        bookEdited: false,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <h1>Class Overview</h1>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Date: </b>
                    <label>{this.state.bookDateToDisplay || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Time: </b>
                    <label>{this.state.bookStartTime || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <br />
                    <br />
                    <pr.PickList
                      source={this.state.pickListAvailable || []}
                      target={this.state.pickListSelected || []}
                      sourceHeader="Available"
                      targetHeader="Selected"
                      responsive={true}
                      itemTemplate={(e) => (
                        <span>{e.firstName + " " + e.surname}</span>
                      )}
                      onChange={(e) => {
                        this.setState({
                          pickListAvailable: e.source,
                          pickListSelected: e.target,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Save"
                    onClick={() => {
                      this.updateClass();
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        bookEdited: false,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="ui-g">
            <div className="ui-g-12">
              <pr.Button
                label="Back"
                onClick={() => {
                  window.location = "#/sets";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/CalendarClass.js